import React from 'react';
import ReactDOM from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import Notification from './index';

export default (selector, initProps) => {
  const render = (Component) => {
    ReactDOM.render(
      <AppContainer>
        <Component initProps={initProps} />
      </AppContainer>,
      document.querySelector(selector),
    );
  };

  render(Notification);

  if (process.env.NODE_ENV === 'development' && module.hot) {
    module.hot.accept('./index', () => {
      // eslint-disable-next-line global-require
      const NextComponent = require('./index').default;
      render(NextComponent);
    });
  }
};



// WEBPACK FOOTER //
// ./app/Assets/js/features/notification/renderInto.js